import { Tooltip as AlchemyTooltip } from '@m/alchemy-ui/Tooltip';
import { useIntl } from 'react-intl';
import { useImageUrl } from '../../../hooks';
import { type FileData } from '../IdeaCard.types';
import * as Styled from './IdeaCard.styled';

const THUMBNAIL_WIDTH = 220;
const THUMBNAIL_HEIGHT = 160;

interface IdeaThumbnailProps {
  readonly imageFile: FileData;
  readonly ideaId: string;
  readonly hasAccess: boolean;
  readonly hasTopBadge?: boolean;
}

export const IdeaThumbnail = ({ imageFile, ideaId, hasAccess, hasTopBadge }: IdeaThumbnailProps) => {
  const intl = useIntl();
  const thumbnailUrl = useImageUrl(imageFile, THUMBNAIL_WIDTH, THUMBNAIL_HEIGHT);
  const noAccessMessage = intl.formatMessage({
    id: 'noAccessToItem',
    defaultMessage: 'You no longer have access to this item'
  });

  const imageEl = thumbnailUrl ? (
    <img src={thumbnailUrl} alt="Idea thumbnail" loading="lazy" />
  ) : (
    <Styled.ThumbnailPlaceholder />
  );

  return (
    <Styled.Thumbnail $hasTopBadge={hasTopBadge}>
      {hasAccess ? (
        <a href={`/post/${ideaId}`} target="_top" aria-hidden="true" tabIndex={-1}>
          {imageEl}
        </a>
      ) : (
        <AlchemyTooltip
          trigger={<span aria-hidden="true">{imageEl}</span>}
          placement="top"
          contents={noAccessMessage}
        />
      )}
    </Styled.Thumbnail>
  );
};
